module.exports = __webpack_public_path__ + "img/bell.7e713f0f.svg";